import PageHeader from "../../components/layout/PageHeader.jsx";
import { useState } from "react";
import SavedNotice from "../../components/common/SavedNotice";
import SelectableGrid from "../../components/common/SelectableGrid";
import StorytellingInterviewsTab from "../../components/storytelling/StorytellingInterviewsTab";
import StorytellingMediaTab from "../../components/storytelling/StorytellingMediaTab";
import StorytellingQuotesTab from "../../components/storytelling/StorytellingQuotesTab";
import StorytellingAnecdotesTab from "../../components/storytelling/StorytellingAnecdotesTab";
import StorytellingShareLinks from "../../components/storytelling/StorytellingShareLinks";
import StorytellingReviewTab from "../../components/storytelling/StorytellingReviewTab";
import useStorytellingSubmissions from "../../hooks/useStorytellingSubmissions";

const TABS = [
  { id: 'interviews', label: 'Interviews' },
  { id: 'media', label: 'Media' },
  { id: 'quotes', label: 'Quotes' },
  { id: 'anecdotes', label: 'Anekdotes' },
  { id: 'review', label: 'Te beoordelen' },
];

/**
 * Het label van een tab. 'Te beoordelen' krijgt het aantal wachtende
 * inzendingen, maar alleen als dat bekend is: zolang er geladen wordt (of het
 * laden mislukte) staat er geen "0".
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * @param {{id: string, label: string}} tab
 * @param {Array<object> | null} submissions
 * @returns {string}
 */
const tabLabel = (tab, submissions) => (tab.id === 'review' && Array.isArray(submissions)
  ? `${tab.label} (${submissions.length})`
  : tab.label);

const Storytelling = () => {
  const [activeTab, setActiveTab] = useState("interviews");
  // Het venster 'Deellink': insturen zonder inlog (docs/features/storytelling-deellink.md).
  const [shareOpen, setShareOpen] = useState(false);
  const { submissions, failed, remove } = useStorytellingSubmissions();

  return (
    <div className="main">
      <div className="main-container">
        <PageHeader
          heading={"Storytelling"}
          description={"Hier kun je de foto's, video's, quotes en anekdotes toevoegen waarmee je je impact laat zien."}
          AI={false}
          actions={<button type="button" onClick={() => setShareOpen(true)}>Deellink</button>}
        />
        {/* Alleen als het venster open is: dicht hoeft het geen activiteiten te lezen. */}
        {shareOpen && <StorytellingShareLinks modalOpen={shareOpen} setModalOpen={setShareOpen} />}
        <SelectableGrid
          items={TABS}
          getId={(item) => item.id}
          getLabel={(item) => tabLabel(item, submissions)}
          selectedId={activeTab}
          onClick={setActiveTab}
        />
        {activeTab === "interviews" && <StorytellingInterviewsTab />}
        {activeTab === "media" && <StorytellingMediaTab />}
        {activeTab === "quotes" && <StorytellingQuotesTab />}
        {activeTab === "anecdotes" && <StorytellingAnecdotesTab />}
        {activeTab === "review" && <StorytellingReviewTab submissions={submissions} failed={failed} onDecided={remove} onOpenTab={setActiveTab} />}
        <div className="impactstrategy-saved-and-nextstep-container">
          <SavedNotice />
        </div>
      </div>
    </div>
  );
};

export default Storytelling;
